import JSZip from 'jszip';
import UPNG from 'upng-js';
import type { DecodedFrame } from './frame-decode';

function safeBaseName(name: string): string {
  const base = name.replace(/\.[^.]+$/, '').replace(/[^\w\u4e00-\u9fff.-]+/g, '_').slice(0, 80);
  return base || 'image';
}

export function frameFilename(sourceName: string, index: number): string {
  return `${safeBaseName(sourceName)}_frame_${String(index + 1).padStart(4, '0')}.png`;
}

export function frameToPng(frame: DecodedFrame): Uint8Array {
  const copy = new Uint8Array(frame.data);
  const encoded = UPNG.encode([copy.buffer], frame.width, frame.height, 0);
  return new Uint8Array(encoded);
}

export async function framesToZip(sourceName: string, frames: DecodedFrame[]): Promise<Uint8Array> {
  const zip = new JSZip();
  for (const frame of frames) zip.file(frameFilename(sourceName, frame.index), frameToPng(frame));
  return new Uint8Array(await zip.generateAsync({ type: 'arraybuffer', compression: 'STORE' }));
}

export function downloadBytes(bytes: Uint8Array, filename: string, type: string): void {
  const url = URL.createObjectURL(new Blob([bytes.buffer], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
